import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import React from "react"

function PayerDashboard(){
    const [tabIndex, setTabIndex] = React.useState(0);
    return <React.Fragment>

    <TabStrip 
        selected={tabIndex}
        onSelect={(e) => setTabIndex(e.selected)}
        style={{ width: "100%" }}>
            <TabStripTab title='Benefits'>
                
            </TabStripTab>
            <TabStripTab title='Authorization'>
                
            </TabStripTab>
            <TabStripTab title='Financial'>

            </TabStripTab>
            <TabStripTab title='Awaiting Service'>
                
            </TabStripTab>

        </TabStrip>
    </React.Fragment>
}
export {PayerDashboard}